/* De daadwerkelijke sectiegrens bepaalt de navigatiekleur, niet een vaste scrollafstand. */
(() => {
  const header = document.querySelector('.shopify-section--header');
  const nextSection = document.querySelector('.hq-home > .fire-stage + section');
  if (!header || !nextSection) return;

  let scheduled = false;
  function update() {
    scheduled = false;
    const nav = header.getBoundingClientRect();
    header.classList.toggle('nav-on-content', nextSection.getBoundingClientRect().top <= nav.bottom);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  function measure() {
    document.documentElement.style.setProperty('--local-nav-height', `${header.getBoundingClientRect().height}px`);
    schedule();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('pageshow', measure);
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);
  document.fonts?.ready.then(measure);
  measure();
})();
